








import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'global-messages'
})

export default class extends Vue {
  private get getMessages(): Array<object> {
    return this.$store.state.GlobalMessages['messages'] || [];
  }
}
